import Div from '@ui/layout/Div'
import { useSelector, useDispatch } from 'react-redux'
import { updateDisplayedContent } from '@store/slice/mediaManagerSlice'
import Icon from '@ui/elements/Icon'
import { useState } from 'react'

const MediaManagerBar = () => {
  const { medias } = useSelector(state => state.mediaManager)
  const dispatch = useDispatch()
  const [activeDistrict, setActiveDistrict] = useState(null)
  const [activeSeason, setActiveSeason] = useState(null)

  const toggleActiveDistrict = districtToActivate => {
    setActiveDistrict(districtToActivate === activeDistrict ? null : districtToActivate)
  }

  const toggleActiveSeason = seasonToActivate => {
    setActiveSeason(seasonToActivate === activeSeason ? null : seasonToActivate)
  }

  const getSeasonDistricts = season => {
    const districts = Object.keys(medias[season]).map(district => {
      return (
        <ul key={`addresses-${district}-${season}`} className={`season-districts ${season === activeSeason ? 'is-active' : 'is-hidden'}`}>
          <li className='district' key={`${district}-${season}`} onClick={() => toggleActiveDistrict(`${district}-${season}`)}>
            {district} <Icon icon={`${district}-${season}` === activeDistrict ? 'icon-keyboard_arrow_down' : 'icon-keyboard_arrow_right'} />
          </li>
          {getDistrictAddresses(season, district)}
        </ul>
      )
    })
    return <ul>{districts}</ul>
  }

  const getDistrictAddresses = (season, district) => {
    const addresses = Object.keys(medias[season][district]).map(address => {
      console.log(address)
      return (
        <li className='address' key={`${address}-${season}`} onClick={() => dispatch(updateDisplayedContent(medias[season][district][address]))}>
          {address}
        </li>
      )
    })
    return (
      <ul className={`district-addresses ${`${district}-${season}` === activeDistrict ? 'is-active' : 'is-hidden'}`}>
        {addresses}
      </ul>
    )
  }

  const barMenu = () => {
    return Object.keys(medias).map(season => {
      return (
        <ul key={`medias-${season}`} className='season-medias'>
          <li className='season' onClick={() => toggleActiveSeason(season)}>
            {season}
            <Icon icon={season === activeSeason ? 'icon-keyboard_arrow_down' : 'icon-keyboard_arrow_right'} />
          </li>
          {getSeasonDistricts(season)}
        </ul>
      )
    })
  }

  return (
    <Div cssClass='menu-manager-bar column is-3'>
      {barMenu()}
    </Div>
  )
}

export default MediaManagerBar